let toastHandler = null;

export function registerToastHandler(handler) {
  toastHandler = handler;
}

export function showToast(message, { isError = false } = {}) {
  if (!message) return;
  if (toastHandler) {
    toastHandler(message, { isError });
    return;
  }
  if (isError) {
    console.error(message);
  } else {
    console.log(message);
  }
}

export function showSuccessToast(message) {
  showToast(message, { isError: false });
}

export function showErrorToast(message) {
  showToast(message, { isError: true });
}
